import React from "react";
import { Assets } from "../../assets";

export const CardLocation = ({
	id = 0,
	selectId = 0,
	background = Assets.texture.casa,
	icon = "",
	name = "",
	action = () => {
		console.log("action");
	},
}) => {
	return (
		<>
			<div className="cardlocationcss bg-blacktransparent rounded-xl cursor-pointer" onClick={action}>
				<div className="xsm:w-[150px] xsm:h-[85px] lg:h-[110px] lg:w-full overflow-hidden px-1 py-2 ">
					<div className="h-full w-full rounded-xl overflow-hidden">
						<div className="containerCardLocation" style={{ backgroundImage: `url(${background})` }}>
							{name !== "n/a" && (
								<div className="relative flex flex-col items-center">
									<img className="h-[30px] w-[30px]" src={icon} alt="icon" />
									<span className="xsm:text-[10px] lg:text-[17px] font-medium text-white">{name}</span>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
